import { rules } from './rules';

export const validateRegister = (formData) => {
  const errors = {};

  const firstNameError = rules.firstName(formData.first_name);
  if (firstNameError) errors.first_name = firstNameError;

  const lastNameError = rules.lastName(formData.last_name);
  if (lastNameError) errors.last_name = lastNameError;

  const emailError = rules.email(formData.email);
  if (emailError) errors.email = emailError;

  const phoneError = rules.phone(formData.phone);
  if (phoneError) errors.phone = phoneError;

  const passwordError = rules.password(formData.password);
  if (passwordError) errors.password = passwordError;

  const passwordConfirmError = rules.passwordConfirmation(
    formData.password_confirmation,
    formData.password,
  );
  if (passwordConfirmError) errors.password_confirmation = passwordConfirmError;

  return errors;
};
